import { type Common } from './common.js';

export class API {
  common: Common;
  baseEndpoint = '/allowed-domains';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(query?: { organizationId?: string }): Promise<string[]> {
    const url = this.common.constructPath(this.baseEndpoint, query);
    return await this.common.getJSON(url);
  }
}
